export const errors = {
    "LOCALISATION_ERROR": "LOCALISATION_ERROR",
    "MAP_ERROR": "MAP_ERROR",
    "INIT_ERROR": "INIT_ERROR",
    "LANG_ERROR": "LANG_ERROR",
    "SEARCH_ERROR": "SEARCH_ERROR",
    "FORM_ERROR": "FORM_ERROR"
}